import React, { useEffect } from "react";
import { List, Avatar, Typography, Space } from "antd";
import {
  CalendarOutlined,
  ForkOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { dashboardPMSApis } from "../../../api/DashboardPMS";

const { Text } = Typography;

// const mockData = [
//   { name: "Financing cost", user: "BH", daysLate: 166, type: "calendar" },
//   { name: "Engineering cost", user: "BH", daysLate: 163, type: "calendar" },
//   { name: "Engineering cost", user: "BH", daysLate: 132, type: "calendar" },
//   { name: "Financing cost", user: "BH", daysLate: 131, type: "calendar" },
//   { name: "Pre Construction Stage", user: "", daysLate: 128, type: "stage" },
//   { name: "Financing cost", user: "BH", daysLate: 128, type: "calendar" },
//   { name: "Financing cost", user: "BH", daysLate: 128, type: "calendar" },
//   { name: "Secure financing", user: "BH", daysLate: 125, type: "calendar" },
// ];

const OverdueWorkItems: React.FC<any> = ({ id }: any) => {
  const [mockData, setMockData] = React.useState<any[]>([]);
  const fetchOverDueWorkItems = async () => {
    try {
      const apiResponse: ApiResponse =
        await dashboardPMSApis.fetchOverDueWorkItemsDashBoard(
          id,
          "overDueWork"
        );
      const { data, status } = apiResponse;
      setTimeout(() => {
        if (status && data) {
          setMockData(data);
        } else {
          setMockData([]);
        }
      }, 800);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchOverDueWorkItems();
  }, [id]);
  return (
    <div
      style={{
        maxHeight: 300,
        overflowY: "auto",
        overflowX: "auto",
        padding: "0 8px",
      }}
    >
      <List
        dataSource={mockData}
        itemLayout="horizontal"
        renderItem={(item) => (
          <List.Item
            style={{
              padding: "8px 4px",
              borderBottom: "1px solid #f0f0f0",
              minWidth: 600, // Ensures horizontal scroll
            }}
          >
            <List.Item.Meta
              avatar={
                item.user ? (
                  <Avatar style={{ backgroundColor: "#f56a00" }}>
                    {item.user}
                  </Avatar>
                ) : (
                  <Avatar icon={<UserOutlined />} />
                )
              }
              title={<Text style={{ fontSize: 14 }}>{item.name}</Text>}
            />
            <Space style={{ marginLeft: "auto" }}>
              {item.type === "calendar" ? (
                <CalendarOutlined />
              ) : (
                // <ForkOutlined />
                <CalendarOutlined />
              )}
              <Text type="danger" strong>
                {item.daysLate}
              </Text>
            </Space>
          </List.Item>
        )}
      />
    </div>
  );
};

export default OverdueWorkItems;
